import maHandleDocument from './views/handleDocumentContainer'

export const documentRouter = [{
  path: '/document/:user/:sinisterId/:warrantyId',
  name: 'handle-document',
  component: maHandleDocument
}]
